import PropTypes from 'prop-types';
import React, { useState } from 'react';
import { v4 as uuid } from 'uuid';
import ListHeader from './ListHeader';
import Row from './Row';
import {updateObjectInListById} from '../../../../lib/FormBuilder/components/FormBuilder/helpers';

const ListBuilder = ({ name, listItems, setListItems }) => {
    const addListItem = () => {
        listItems.push({ id: uuid() });
        setListItems(name, [...listItems]);
    };

    const removeListItem = (item) => {
        if (listItems.length > 1) {
            setListItems(name, [...listItems.filter((i) => item.id !== i.id)]);
        }
    };

    const updateLabel = (item, value) => {
        const _listItems = updateObjectInListById(listItems, item.id, { label: value });
        setListItems(name, _listItems);
    };

    const updateValue = (item, value) => {
        const _listItems = updateObjectInListById(listItems, item.id, { value });
        setListItems(name, _listItems);
    };

    return (
        <div>
            <ListHeader />
            {listItems && listItems.map((item) => (
                <Row
                    key={item.id}
                    item={item}
                    addItem={addListItem}
                    removeItem={removeListItem}
                    disableRemove={(listItems.length === 1)}
                    updateLabel={updateLabel}
                    updateValue={updateValue}
                />
            ))}
        </div>
    );
};
export default ListBuilder;

ListBuilder.propTypes = {
    listItems: PropTypes.array.isRequired,
    name: PropTypes.string,
    setListItems: PropTypes.func.isRequired,
};
